import React from "react";
import { array, object, bool, string } from "prop-types";

import CustomStoryCard3 from "../../../../molecules/CustomStoryCard3";
import LiveBlogStoryCard from "../../../../molecules/LiveBlogStoryCard";
import { getKeyHighlights } from "../../../../utils/utils";

import "./organism1.m.css";

const Organism1 = ({ stories, updatedFont, publisherLang, src, liveBlogStory }) => (
  <div styleName="base">
    {stories.map(({ story }, index) => (
      <div styleName="story-card" key={index}>
        {index === 0 && story["story-template"] === "live-blog" && liveBlogStory && liveBlogStory.id === story.id
          ? renderLiveBlogOrStory(liveBlogStory, index, updatedFont, publisherLang, src)
          : renderLiveBlogOrStory(story, index, updatedFont, publisherLang, src)}
      </div>
    ))}
  </div>
);

const renderLiveBlogOrStory = (story, index, updatedFont, publisherLang, src) => {
  if (story["story-template"] === "live-blog" && global.deviceWidth < 1264 && story.cards) {
    const keyHighlights = getKeyHighlights(story.cards);
    return (
      <LiveBlogStoryCard
        story={story}
        keyHighlights={keyHighlights}
        updatedFont={updatedFont}
        publisherLang={publisherLang}
      />
    );
  } else {
    return (
      <CustomStoryCard3
        story={story}
        isExcerpt={true}
        updatedFont={updatedFont}
        publisherLang={publisherLang}
        src={src}
        datatrackingcategory="Component One"
        datatrackingaction="Click"
        datatrackinglabel={`Position-${index + 2}`}
      />
    );
  }
};
Organism1.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  updatedFont: bool,
  src: string,
  publisherLang: string,
  liveBlogStory: object,
};

export default Organism1;
